import { useEffect, type ReactNode } from 'react';
import { COMMAND_CENTER_PATH, METRIC_DICTIONARY_PATH, PROFICIENCY_PATH, SCOREBOARD_PATH, type AnalyticsAudience } from '@nest-recruit/shared';
import { Card } from '../../../components/Card';
import { SkeletonLines } from '../../../components/Skeleton';
import { router } from '../../../router';
import { useCanView } from '../../../stores/session';
import { useReportLibrary } from '../api/analytics-api';

const LANDING: Readonly<Record<AnalyticsAudience, string>> = {
  all: COMMAND_CENTER_PATH,
  recruiter: PROFICIENCY_PATH,
  manager: SCOREBOARD_PATH,
};

/** `/reports`: each person's own first report — by route change, never a page load. */
export function ReportsIndexPage(): ReactNode {
  const isHrLead = useCanView('reports_all_staff');
  const library = useReportLibrary();
  const audience = library.data?.audience;
  const target = landingFor(isHrLead, audience, library.error !== null);
  useEffect(() => {
    if (target) router.history.replace(target);
  }, [target]);
  return (
    <Card>
      <SkeletonLines count={4} />
    </Card>
  );
}

function landingFor(isHrLead: boolean, audience: AnalyticsAudience | undefined, hasFailed: boolean): string | null {
  if (isHrLead) return COMMAND_CENTER_PATH;
  if (audience) return LANDING[audience];
  return hasFailed ? METRIC_DICTIONARY_PATH : null;
}
